import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    iconContainer: {
        marginLeft: 16,
        height: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default styles;
